<template>
  <div id="app">
    <vue-slider
      ref="v-slider"
      v-model="currentValue"
      :callback="callback"
      :dot-size="18"
      :height="12"
      :formatter="(v) => formatValue(v)"
      :interval="interval"
      :lazy="false"
      :min="min"
      :max="max"
      :disabled="readonly"
      :piecewise="false"
      :piecewise-label="true"
      :speed="0.5"
      :tooltip="'never'"
      :value="value"
      :width="'auto'"
    >
      <template slot="label" slot-scope="{ label }">
        <div v-if="isValidLabel(label)">
          <span class="vue-slider-label" @click="(e)=>setValue(e, label)">{{ formatMoney(label) }}</span>
        </div>
      </template>
    </vue-slider>
  </div>
</template>

<script>
import vueSlider from 'vue-slider-component';
import { formatMoney } from '@/modules/utils';

export default {
  name: 'CircleSlider',
  components: { vueSlider },
  props: {
    value: Number,
    max: Number,
    min: Number,
    interval: Number,
    labelCount: Number,
    readonly: Boolean,
    labelValues: Array,
    validValues: Array,
    onSliderChange: Function
  },
  data () {
    return {
      currentValue: 0,
      labelValue: 0,
      setByLabel: false
    };
  },
  computed: {

  },
  created() {
    this.currentValue = this.value;
  },
  methods: {
    callback(value) {
      console.log(value);
    },
    findValidValue(value) {
      if (this.validValues && this.validValues.length) {
        const _value = this.validValues.reduce((prev, curr) => Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev);
        return _value;
      }
      return this.value;
    },
    formatValue(value) {
      if (this.validValues && this.validValues.length) {
        if (this.validValues.findIndex(_value => _value === value) >= 0) {
          return value;
        }
      }
      return ''; // this.value;
    },
    isValidLabel(value) {
      const _index = this.labelValues.findIndex(_label => _label == value);
      if (_index >= 0) {
        return true;
      }
      return false;
    },
    setValue(e, value) {
      e.preventDefault();
      const _value = parseInt(value, 10);
      this.labelValue = _value;
      this.setByLabel = true;
    },
    formatMoney
  },
  watch: {
    currentValue: {
      handler(value) {
        let _value = this.formatValue(value);
        _value = parseInt(_value, 10);
        if (isNaN(_value) || !_value) {
          _value = this.findValidValue(value);
        }
        this.$emit('change', _value);
      }
    },
    value: {
      handler(value) {
        if (this.setByLabel) {
          this.currentValue = this.labelValue;
          this.setByLabel = false;
        } else {
          this.currentValue = value;
        }
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/thirdparty/BarSlider/BarSlider.vue